import { Pencil } from "lucide-react";
import { Button } from "./Button";

export type ReviewChecklistItem<Key extends string> = { key: Key; label: string; description?: string };

/** Labels are presentation; required keys and command rules come from shared schemas. */
export function ReviewChecklist<Key extends string>({ items, value, onChange, onEdit, disabled = false }: {
  items: readonly ReviewChecklistItem<Key>[];
  value: Partial<Record<Key, boolean>>;
  onChange: (key: Key, checked: boolean) => void;
  onEdit?: (key: Key) => void;
  disabled?: boolean;
}) {
  return <div className="v365-review-checklist">{items.map(item => <div className="v365-review-item" key={item.key}>
    <label className="v365-review-label"><input type="checkbox" data-validation-field={`checklist.${item.key}`} checked={value[item.key] === true} disabled={disabled} onChange={event => onChange(item.key, event.target.checked)} /><span><strong>{item.label}</strong>{item.description && <span>{item.description}</span>}</span></label>
    {onEdit && <Button variant="secondary" fullWidth={false} disabled={disabled} aria-label={`Review ${item.label}`} icon={<Pencil aria-hidden size={16} />} onClick={() => onEdit(item.key)}>Open</Button>}
  </div>)}</div>;
}
